import { Component, OnInit } from '@angular/core';
import { DataTypeComponent } from '../../data-type-component';
import { AffordabilitySettingsService } from './affordability-settings.service';
import { AffordabilityParamsDTO } from './affordability-settings.model';

@Component({
  selector: 'app-affordability-settings',
  templateUrl: './affordability-settings.component.html',
  styleUrls: ['./affordability-settings.component.scss'],
  standalone: false,
})
export class AffordabilitySettingsComponent extends DataTypeComponent implements OnInit {
  constructor(private service: AffordabilitySettingsService) {
    super();
  }

  params?: AffordabilityParamsDTO;

  ngOnInit(): void {
    this.service.get().subscribe((params) => (this.params = params));
  }
}
